// frontend/src/components/EmpresaPortal/VistaProximamente.js
//
// Placeholder para las secciones del sidebar que todavía no tienen pantalla
// propia (Candidatos, Evaluaciones, Mis stacks, Resultados, Configuración
// como vistas dedicadas). El contenido real de esas secciones hoy vive
// dentro del Dashboard; esta vista es solo el punto de entrada visual hasta
// que se separen.

import React from 'react';

const VistaProximamente = ({ icon: Icon, titulo, descripcion }) => (
  <div className="ep-card ep-proximamente">
    <div className="ep-proximamente-icon">
      <Icon size={28} />
    </div>
    <h2>{titulo}</h2>
    <p className="ep-hint">{descripcion}</p>
    <span className="ep-badge-origen ep-badge-propia">Próximamente</span>
  </div>
);

export default VistaProximamente;
